module.exports = __webpack_public_path__ + "img/horizontal_4_4_7005.e7077cfa.png";